<template>
  <div>
    <layout-error>
      <card-error
        :error_on_back="$t('messages.errors.not_found.error_on_back')"
        :message="$t('messages.errors.not_found.message')"
      />
    </layout-error>
  </div>
</template>
<script>
  import {ZoomCenterTransition} from 'vue2-transitions';
  import {mapGetters, mapActions} from "vuex";
  import vuex from "../../../vuex";
  import * as Cookies from "js-cookie";
  import CardError from "./partials/CardError";
  import LayoutError from "./partials/LayoutError";
  import router from "@/http/router";
  export default {
    name: "NoPermission",
    components: {
      ZoomCenterTransition,
      CardError,
      LayoutError
    },
    props: {
      backgroundColor: {
        type: String,
        default: 'black'
      }
    },
    data() {
      return {
        showMenu: false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 200,
        year: new Date().getFullYear(),
        pageClass: 'login-page'
      };
    },
    computed: {
      token() {
        return Cookies.getJSON("token");
      },
      title() {
        return `${this.$route.name} Page`;
      }
    },
    methods: {
      ...mapActions(["redirectToMainMenu"]),
      backToDashboard(){
        this.redirectToMainMenu();
      }
    },
  };
</script>
<style lang="scss" scoped>

  .jumbo {
    font-size: 8rem !important;
  }

  .navbar.auth-navbar {
    top: 0;
  }

  $scaleSize: 0.8;
  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }

  .wrapper-full-page .zoomIn {
    animation-name: zoomIn8;
  }

  @keyframes zoomOut8 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .wrapper-full-page .zoomOut {
    animation-name: zoomOut8;
  }
</style>
